import * as React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { formatNumber } from '@telerik/kendo-intl';
import * as moment from 'moment';
import { fetchApi } from '../../services/api';
const DocumentTitle = require('react-document-title');

type Props = RouteComponentProps<{ }>;

type State = {
    expiringRates: ReportData[];
}

type ReportData = {
    ChildID: number;
    ChildName: string;
    Amount: number;
    RateType: string;
    EffectiveStartDate: Date;
    EffectiveEndDate: Date;
}

class ExpiringRates extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            expiringRates: [],
        }
    }

    public componentWillMount() {
        this.getReport();
    }

    public render() {
        return <React.Fragment>
            <DocumentTitle title="Expiring Rates" />
            <h1>Expiring Rates (30 Days)</h1>
            { this.renderReportTable() }
        </React.Fragment>;
    }

    private renderReportTable() {
        return <table className='table'>
            <thead>
                <tr>
                    <th>Child Name</th>
                    <th>Rate</th>
                    <th>Effective From</th>
                    <th>Effective To</th>
                </tr>
            </thead>
            <tbody>
                {this.state.expiringRates.map((expiringRate, index) =>
                    <tr key={ index }>
                        <td>
                            <Link to={ `/child/${ expiringRate.ChildID }/rates` }>
                                {expiringRate.ChildName}
                            </Link>
                        </td>
                        <td>{formatNumber(expiringRate.Amount, "c")} / {expiringRate.RateType}</td>
                        <td>{moment(expiringRate.EffectiveStartDate).format("YYYY-MM-DD")}</td>
                        <td>{moment(expiringRate.EffectiveEndDate).format("YYYY-MM-DD")}</td>
                    </tr>
                )}
            </tbody>
        </table>;
    }

    private getReport() {
        const data = {
            FacilityID: localStorage.getItem("FACILITY_ID")
        }
        fetchApi('/api/Reports/ExpiringRates', data, 'POST')
            .then((expiringRates: ReportData[]) => {
                this.setState({ expiringRates })
            })
    }
}

export default ExpiringRates;
